import { Injectable, inject } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

/** Réponse de GET /info (administrateurs) : `version` = Cargo.toml racine du serveur, `release` = son fichier release tel quel. */
export interface ServerInfo {
  version: string | null;
  apiserver_version: string | null;
  environment: string;
  config: Record<string, unknown> | null;
  release: string;
}

@Injectable({ providedIn: 'root' })
export class ServerInfoService {
  private http = inject(HttpClient);
  // Hors intercepteurs : un refus de /version passerait le front « hors ligne », et le retour en ligne la relancerait toutes les 10 s.
  private bare = new HttpClient(inject(HttpBackend));

  /** Version du serveur (GET /version, jeton exigé : jamais publique) ; null en cas de refus ou de serveur muet. */
  version$(): Observable<string | null> {
    const token = localStorage.getItem('token');
    if (!token) return of(null);
    return this.bare.get<{ version: string | null }>(`${environment.server_url}/version`, { headers: { Authorization: 'Bearer ' + token } }).pipe(
      map(r => r?.version ?? null),
      catchError(() => of(null)),
    );
  }

  info$(): Observable<ServerInfo> {
    return this.http.get<ServerInfo>(`${environment.server_url}/info`);
  }
}
